export default {"src":"https://search.prod.wiggot.com/_next/static/media/priceEngine.b587f22f.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};